import { formatDateOnly } from '../../../common/utils/date';
import { PREG_STATE } from '../../../core/constants/dx';
import StatsView from '../../stats/layouts/entity-stats';
import MedicalEventsPanel from '../../medical/forms/events-panel';
import { useRecipient } from '../contexts/recipients';

import './styles/stats.css';

// KPI / dashboard de una receptora (admin-recipients.md · view=full, 0041). Reusa
// StatsView (producción + embudo transferidos→confirmadas→partos + tasas) y añade
// el estado actual, el historial de transferencias (cruce/outcome) y eventos médicos.

const OUTCOME = {
    born:     { label: 'Nacida',   tone: 'good' },
    lost:     { label: 'Perdida',  tone: 'bad' },
    en_curso: { label: 'En curso', tone: 'open' },
};
function CurrentPanel({ current }) {
    if (!current) return null;
    const p = current.pregnancy;
    return (
        <article className="report-card rcp-stats__panel">
            <h2 className="report-section__title">Estado actual</h2>
            {current.available ? (
                <p className="rcp-stats__free"><span className="rcp-badge rcp-badge--good">Libre</span> Disponible para una nueva transferencia.</p>
            ) : p ? (
                <div className="rcp-stats__current">
                    <span className={`rcp-badge rcp-badge--${PREG_STATE[p.state]?.tone || 'open'}`}>{PREG_STATE[p.state]?.label || p.state}</span>
                    {p.estimated && <span className="rcp-stats__fact">Parto estimado: <strong>{formatDateOnly(p.estimated)}</strong></span>}
                    {p.next_dx?.scheduled_for && (
                        <span className="rcp-stats__fact">
                            Próximo dx{p.next_dx.number ? ` ${p.next_dx.number}` : ''}: <strong>{formatDateOnly(p.next_dx.scheduled_for)}</strong>
                            {p.next_dx.due && <span className="rcp-stats__due"> vencido</span>}
                        </span>
                    )}
                </div>
            ) : (
                <p className="rcp-stats__free">Sin preñez activa.</p>
            )}
        </article>
    );
}

function HistoryPanel({ history }) {
    const rows = history || [];
    return (
        <article className="report-card rcp-stats__panel">
            <h2 className="report-section__title">Historial de transferencias</h2>
            {!rows.length ? (
                <p className="rcp-stats__muted">Sin transferencias.</p>
            ) : (
                <table className="rcp-stats__table">
                    <thead>
                        <tr><th>T.E.</th><th>Fecha</th><th>Finca</th><th>Embrión</th><th>Donadora × Toro</th><th>Resultado</th></tr>
                    </thead>
                    <tbody>
                        {rows.map((h) => {
                            const oc = OUTCOME[h.outcome];
                            const st = PREG_STATE[h.pregnancy?.state];
                            return (
                                <tr key={h.transfer_id}>
                                    <td>{h.te_session?.code || '—'}</td>
                                    <td>{formatDateOnly(h.te_date) || '—'}</td>
                                    <td>{h.farm?.name || '—'}</td>
                                    <td>{h.embryo?.code || '—'}</td>
                                    <td className="rcp-stats__cross">{h.cruce ? `${h.cruce.donor?.name || '—'} × ${h.cruce.sire?.name || '—'}` : '—'}</td>
                                    <td>{oc ? <span className={`rcp-badge rcp-badge--${oc.tone}`}>{oc.label}</span> : st ? <span className={`rcp-badge rcp-badge--${st.tone}`}>{st.label}</span> : '—'}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
        </article>
    );
}

export default function RecipientStats({ recipientId }) {
    const { data: r, isLoading, isFetching, error } = useRecipient(recipientId, 'full');
    const label = r ? `${r.number || `#${recipientId}`}${r.name ? ` · ${r.name}` : ''}` : `#${recipientId}`;
    const subtitle = r ? [r.farm?.name && `Finca ${r.farm.name}`, r.client?.name].filter(Boolean).join(' · ') : undefined;

    return (
        <StatsView
            data={r?.stats}
            title={`Receptora ${label}`}
            subtitle={subtitle}
            backTo="/admin/recipients"
            backLabel="Receptoras"
            isLoading={isLoading}
            isFetching={isFetching}
            error={error}
        >
            {r && <CurrentPanel current={r.current} />}
            {r && <HistoryPanel history={r.history} />}
            {r && <MedicalEventsPanel recipientId={r.id} />}
        </StatsView>
    );
}
